import { statuses } from '../constants';

const getStatus = (docuform) => {
  let status = docuform.status;

  if (status === 'Pending') {
    const signatureRequired = docuform.activity_metadata_flat?.find(item => item.key === 'signature_required' && item.value);
    status = signatureRequired || docuform.metadata?.signature_required ? 'PendingApproval' : 'PendingReview';
  }

  return statuses[status];
};

export default getStatus;
